import { Controller } from "@hotwired/stimulus"
import { verifyStream, describeResult } from "../ga4_verify"

export default class extends Controller {
  static targets = ["rows", "template"]

  add(event) {
    event.preventDefault()
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, Date.now().toString())
    this.rowsTarget.insertAdjacentHTML("beforeend", html)
  }

  async verify(event) {
    event.preventDefault()
    const row = event.currentTarget.closest("[data-ga4-streams-row]")
    const field = name => row.querySelector(`[name$='[${name}]']`).value
    const output = row.querySelector("[data-ga4-streams-result]")
    output.textContent = "Checking…"
    const result = await verifyStream({
      platform: field("platform"), property_id: field("property_id"), stream_id: field("stream_id")
    })
    output.replaceChildren(...describeResult(result).map(line => {
      const div = document.createElement("div")
      div.textContent = line
      return div
    }))
  }

  // Persisted rows are flagged with _destroy and hidden; unsaved rows are just removed.
  remove(event) {
    event.preventDefault()
    const row = event.currentTarget.closest("[data-ga4-streams-row]")
    const destroy = row.querySelector("input[name$='[_destroy]']")
    if (destroy) {
      destroy.value = "1"
      row.style.display = "none"
    } else {
      row.remove()
    }
  }
}
